import React, { useState, useRef } from "react";
import { FiEye } from "react-icons/fi";
import { FiEyeOff } from "react-icons/fi";
import LoginWithPassWord from "./LoginWithPassWord";
import LoginMpinPassWord from "./LoginMpinPassWord";
import ForgotMpinOtp from "./ForgotMpinOtp";
import { useNavigate } from "react-router-dom";
import axios from "../../axios";
import { useDispatch } from "react-redux";
import {
  loginStart,
  loginFailure,
  loginSuccess,
} from "../../redux/userReducer";
import { TextField, CircularProgress } from "@mui/material";
import RunningLoader from "../../components/ui/runningLoader";

export default function LoginWithMpin({
  studentDetails,
  setLogin,
  setRegister,
}) {
  const [showMpin, setShowMpin] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isInProgress, setIsInProgress] = useState(false);

  // 🔥 Naya state: Login success loader ke liye
  const [loginSuccessState, setLoginSuccessState] = useState(false);

  const [loginWithMpin, setLoginWithMin] = useState({
    loginInstedPass: false,
    backArrow: false,
    forgotMpin: false,
    loginSucess: false,
  });

  const [mpin, setMpin] = useState(Array(6).fill(""));

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const inputsRef = useRef([]);
  const schoolCode = localStorage.getItem("schoolCode");

  const toggleShowMpin = () => {
    setShowMpin(!showMpin);
  };

  const handleChange = (e, i) => {
    const val = e.target.value.replace(/[^0-9]/g, "");
    if (!val) return;

    const newMpin = [...mpin];
    newMpin[i] = val.slice(-1);
    setMpin(newMpin);

    if (i < 5 && val) {
      inputsRef.current[i + 1].focus();
    }
  };

  const handleKeyDown = (e, i) => {
    if (e.key === "Backspace") {
      const newMpin = [...mpin];
      if (mpin[i]) {
        newMpin[i] = "";
        setMpin(newMpin);
      } else if (i > 0) {
        inputsRef.current[i - 1].focus();
        newMpin[i - 1] = "";
        setMpin(newMpin);
      }
      e.preventDefault();
    }
  };

  const handleLogin = async () => {
    setIsInProgress(true);
    dispatch(loginStart());

    try {
      let res = await axios.post(`/studentAuth/loginWithMpin`, {
        unique_id: studentDetails?.addmissionNumber,
        mpin: mpin.join(""),
        school_code: schoolCode,
      });

      if (res) {
        dispatch(loginSuccess(res.data.data));
        localStorage.setItem(
          "School_id",
          JSON.stringify(res?.data?.data?.addmission_no),
        );
        localStorage.setItem(
          "features",
          JSON.stringify(res.data?.data?.features),
        );
        localStorage.setItem(
          "AuthToken",
          JSON.stringify(res.data?.data?.accessToken),
        );
        localStorage.setItem("homeSideMenu", "Dashboard");

        // 🔥 Yahan navigate nahi karenge, loader dikhayenge
        setLoginSuccessState(true);

        // 3 second baad direct dashboard par bhej denge
        setTimeout(() => {
          navigate("/HomePage");
        }, 3000);
      }
    } catch (error) {
      dispatch(loginFailure());
      setErrorMessage(error?.response?.data?.message || "Something went wrong");
      setIsInProgress(false);
      console.log(error);
    }
  };

  const changeName = (str) => {
    return str.replace("school", "institute");
  };

  const isMpinComplete = mpin.join("").length === 6;

  // 🔥 Agar login successful hai, toh RunningLoader dikhao
  if (loginSuccessState) {
    return <RunningLoader />;
  }

  return (
    <div>
      {!loginWithMpin.loginInstedPass &&
        !loginWithMpin.backArrow &&
        !loginWithMpin.forgotMpin &&
        !loginWithMpin.loginSucess && (
          <div className="ContainerRegister h-100">
            <div className="row">
              <div className="col-md-3 p-0 bannerContainer">
                <img
                  className="bannerImg"
                  alt="icon"
                  src="/LoginRegister/BannerImg.png"
                ></img>
              </div>
              <div className="col-md-9 RegisterDetailContainer">
                <>
                  <div
                    className="backLoginIcon"
                    onClick={(e) =>
                      setLogin((prev) => ({
                        ...prev,
                        mpinLogin: false,
                        passwordLogin: false,
                      }))
                    }
                  >
                    <img src="/LoginRegister/LoginBackIcon.png" alt="icon" />
                  </div>
                  <div className="InsideDetailCpntainer">
                    <div className="d-flex justify-content-center">
                      <img
                        className="registrationIcon"
                        src="/StudentImg/BreathSchoolLogo.png"
                        alt="icon"
                      />
                    </div>
                    <div className="d-flex justify-content-center headerRegistration mt-3">
                      Welcome back!
                    </div>
                    <div className="UnlockFaceIdText d-flex justify-content-center mt-2 ">
                      Login with PIN
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-4">
                      <TextField
                        id="outlined-read-only-input"
                        label="Login ID"
                        className="registrationMPinInput"
                        readOnly="true"
                        value={studentDetails?.addmissionNumber}
                        slotProps={{
                          input: {
                            readOnly: true,
                          },
                        }}
                      />
                    </div>
                    <div
                      style={{ borderColor: errorMessage && "#D40D12" }}
                      className="w-full flex justify-between items-center registrationInput-pin mt-4"
                    >
                      <div className="flex gap-3">
                        {mpin?.map((val, i) => (
                          <input
                            key={i}
                            ref={(el) => (inputsRef.current[i] = el)}
                            type={showMpin ? "text" : "password"}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            maxLength={1}
                            value={val}
                            placeholder="_"
                            onChange={(e) => handleChange(e, i)}
                            onKeyDown={(e) => handleKeyDown(e, i)}
                            style={{
                              width: 44,
                              height: 52,
                              textAlign: "center",
                              fontSize: 24,
                              border: "1px solid #ccc",
                              borderRadius: 8,
                            }}
                          />
                        ))}
                      </div>
                      <div>
                        <span
                          onClick={toggleShowMpin}
                          style={{ cursor: "pointer", color: "#555" }}
                        >
                          {showMpin ? <FiEye /> : <FiEyeOff />}
                        </span>
                      </div>
                    </div>
                    <div className="mt-2">
                      {errorMessage && (
                        <span className="text-red-600 text-[16px] font-medium flex items-center gap-1">
                          <p>
                            ⚠️{" "}
                            {errorMessage.length > 35 ? (
                              <>
                                {changeName(errorMessage.substring(0, 35))}{" "}
                                <br />
                                {changeName(errorMessage.substring(35))}
                              </>
                            ) : (
                              changeName(errorMessage)
                            )}
                          </p>
                        </span>
                      )}
                    </div>
                    <div className="d-flex flex-column justify-content-center mt-4">
                      <button
                        type="submit"
                        disabled={!isMpinComplete || isInProgress}
                        className="RegisterBtn"
                        onClick={handleLogin}
                        style={{
                          opacity: !isMpinComplete || isInProgress ? 0.6 : 1,
                          cursor:
                            !isMpinComplete || isInProgress
                              ? "not-allowed"
                              : "pointer",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        {isInProgress && (
                          <CircularProgress size={18} sx={{ color: "#fff" }} />
                        )}
                        {isInProgress ? "Logging in..." : "Login"}
                      </button>
                    </div>

                    <div
                      className="skipfacetext d-flex justify-content-center mt-3"
                      onClick={() =>
                        setLoginWithMin({
                          ...loginWithMpin,
                          forgotMpin: true,
                        })
                      }
                      style={{ cursor: "pointer" }}
                    >
                      Forgot PIN?
                    </div>
                    <div className="d-flex justify-content-center mt-5">
                      <div
                        className="loginpasswordInstead mt-5"
                        onClick={(e) => {
                          setLoginWithMin({
                            ...loginWithMpin,
                            loginInstedPass: true,
                          });
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        Login with Password instead{" "}
                      </div>
                    </div>
                  </div>
                </>
              </div>
            </div>
          </div>
        )}
      {loginWithMpin.loginInstedPass && (
        <LoginWithPassWord
          studentDetails={studentDetails}
          setLogin={setLogin}
        />
      )}
      {loginWithMpin.backArrow && (
        <LoginMpinPassWord
          studentDetails={studentDetails}
          setLogin={setLogin}
          setIsInProgress={setIsInProgress}
        />
      )}
      {loginWithMpin.forgotMpin && (
        <ForgotMpinOtp
          studentDetails={studentDetails}
          setRegister={setRegister}
          setIsInProgress={setIsInProgress}
        />
      )}
    </div>
  );
}
